import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-digest-stats-trend",
  templateUrl: "./trend.component.html",
})
export class DigestStatsTrendComponent {
  @Input() public trend: string;
  @Input() public neutralTrend: boolean;
  @Input() public increasePositive: boolean;

  public isPositiveTrend(trend: string) {
    if (this.increasePositive) {
      return this.isTrendIncrease(trend);
    } else {
      return !this.isTrendIncrease(trend);
    }
  }

  private isTrendIncrease(trend: string) {
    return trend[0] === "↑";
  }
}
